export default "__VITE_ASSET__Duo_PUWA__"